const pl = {
  tours: {
    pkg1: {
      price: "€790",
      title: "Luksusowa weekendowa ucieczka w Europie/Maroko",
      duration: "3 noce / 4 dni ",
      hl1: "W cenie bezpośrednie loty w obie strony (Londyn/Europa)",
      hl2: "Luksusowe hotele 4–5 gwiazdek",
      hl3: "Tradycyjna marokańska łaźnia turecka",
      hl4: "Warsztaty kulinarne i artystyczne",
      hl5: "Marokańskie występy na żywo",
      hl1_brief: "W cenie bezpośrednie loty w obie strony",
      subtitle: "Pakiet All Inclusive – Od A do Z",
      flight1: "Bezpośrednie loty w obie strony",
      flight2: "Bagaż rejestrowany 20kg",
      flight3: "Bagaż kabinowy do 8 kg",
      inc1: "Odbiór z lotniska i transfer z powrotem",
      inc2: "Hotele 4–5 gwiazdkowe (śniadanie i obiadokolacja)",
      inc3: "Świeża i autentyczna kuchnia marokańska",
      inc4: "Tradycyjna herbata i ciastka",
      inc5: "Profesjonalny przewodnik i prywatny kierowca",
      inc6: "Nowoczesny, klimatyzowany transport",
      inc7: "Specjalne występy na żywo (śpiewacy i tancerze)",
      inc7_brief: "Specjalne występy na żywo",
      inc8: "Tradycyjne wycieczki po targu (przyprawy, latarnia, dywan)",
      inc8_brief: "Tradycyjne wycieczki po rynku",
      inc9: "Warsztaty kulinarne i artystyczne (wymagana wcześniejsza rezerwacja)",
      inc9_brief: "Warsztaty kulinarne i plastyczne",
      inc10: "Wizyty w naturalnych źródłach i punktach widokowych",
      inc11: "Jednodniowe wycieczki do Szafszawanu i Ifrane",
      inc12: "Wizyty u lokalnych rodzin marokańskich",
      inc13: "Niespodzianki podczas wycieczki",
      suit1: "Pary",
      suit2: "Rodziny",
      suit3: "Grupy",
      suit4: "Podróżujący samotnie",
      suit5: "Seniorzy",
      suit6: "Firmy",
      suit7: "Biura podróży",
      suit8: "Organizatorzy wycieczek"
    },
    pkg2: {
      price: "€1490",
      title: "Luksusowa wycieczka odkrywcza po Maroku",
      duration: "6 nocy / 7 dni ",
      hl1: "Pakiet A",
      hl2: "Ruchy Atlasa",
      hl3: "Marakech- Essaouira – Merzouga – Ouarzazte – Marakech-",
      hl4: "Wielka niespodzianka ❤️",
      hl5: "Pakiet B",
      subtitle: "Trasa Fez i Północne Maroko (all inclusive)",
      routeText: "2 noce Fez, 1 noc Szafszawan, 1 noc Tanger, 1 noc Ifrane, 1 ostatnia noc Fez",
      flight1: "Bezpośrednie loty w obie strony z Europy",
      flight2: "Bagaż 20kg + bagaż kabinowy",
      trans1: "Odbiór z lotniska i transfer",
      trans2: "Prywatny, profesjonalny kierowca i przewodnik",
      trans3: "Nowe, klimatyzowane pojazdy",
      hotel1: "Hotele 4-5 gwiazdkowe",
      hotel2: "Lokalizacje premium",
      hotel3: "Obsługa na wysokim poziomie",
      food1: "Częściowe wyżywienie",
      food2: "Autentyczna kuchnia",
      food3: "Tradycyjna herbata i ciastka",
      exp1: "Marokańskie występy na żywo",
      exp2: "Tradycyjne targi (przyprawy, latarnia, dywan)",
      exp2_brief: "Tradycyjne rynki",
      exp3: "Tradycyjna marokańska łaźnia turecka",
      exp4: "Wizyty w przyrodzie i lesie",
      exp4_brief: "Wizyty natury",
      exp5: "Piękne punkty widokowe i jednodniowe wycieczki",
      exp6: "Warsztaty kulinarne i artystyczne",
      exp7: "Wizyty u lokalnych rodzin",
      exp8: "Specjalne niespodzianki podczas podróży",
      suit1: "Pary",
      suit2: "Rodziny",
      suit3: "Grupy",
      suit4: "Podróżujący samotnie",
      suit5: "Seniorzy",
      suit6: "Firmy",
      suit7: "Biura podróży"
    },
    pkg3: {
      price: "€1990",
      title: "Wielkie doświadczenie Maroka",
      duration: "10 nocy / 11 dni ",
      hl1: "Pełne usługi naziemne premium",
      hl2: "Casablanca, Marakesz i Fez",
      hl3: "Niespodzianki na pustyni Agadir i Sahara",
      hl4: "Odwiedź Warzazate i Szafszawan",
      hl5: "Specjalna muzyka na żywo i występy",
      subtitle: "✨ Wielkie doświadczenie Maroka (tylko usługi naziemne)",
      arrivalText: "Casablanca czy Marakesz",
      routeText: "Casablanca, Rabat, 2 noce Fez, Tanger, Szafszawan, Ifrane, 2 noce Marrakesz, Agadir, Ouarzazate, ostatnia noc Marrakesz",
      note2: "Grupy > 40: Specjalna zniżka w wysokości 50 USD za osobę",
      note3: "Loty międzynarodowe i ubezpieczenie NIE są wliczone w cenę",
      note4: "Wskazówki dla kierowcy/przewodnika NIE są uwzględnione",
      inc1: "Pełne usługi naziemne premium",
      inc2: "Hotele 4–5 gwiazdkowe (śniadanie i obiadokolacja)",
      inc3: "Profesjonalny przewodnik i prywatny kierowca",
      inc4: "Klimatyzowany autobus lub minibus",
      inc5: "Występy na żywo i atmosfera muzyczna",
      inc6: "Tradycyjne targi i wizyty w łaźni tureckiej",
      inc7: "Warsztaty kulinarne i artystyczne",
      inc8: "Wycieczki do lasów, źródeł i punktów widokowych",
      inc9: "Wizyty u lokalnych rodzin",
      inc10: "Specjalne niespodzianki podczas podróży"
    },
    pageTitle: "Wycieczki i pakiety",
    pageSubtitle: "Wybierz jeden z naszych starannie dobranych pakietów wycieczek po Maroku",
    sectionTitle: "Nasze pakiety wycieczek",
    sectionIntro: "Od pustynnych przygód po ucieczki na wybrzeże – mamy idealny pakiet dla każdego podróżnika",
    howToBook: "Jak zarezerwować",
    step1Title: "Wybierz wycieczkę",
    step1Text: "Przejrzyj nasze pakiety i wybierz ten, który najbardziej Ci odpowiada",
    step2Title: "Kliknij Zarezerwuj teraz",
    step2Text: "Kliknij przycisk „Zarezerwuj teraz” przy wybranej wycieczce",
    step3Title: "Wypełnij szczegóły",
    step3Text: "Podaj daty podróży i dane osobowe",
    step4Title: "Potwierdzenie",
    step4Text: "Otrzymaj potwierdzenie i szczegóły trasy e-mailem",
    customTitle: "Potrzebujesz pakietu niestandardowego?",
    customText: "Skontaktuj się z nami, aby stworzyć spersonalizowaną wycieczkę po Maroku",
    customBtn: "Skontaktuj się",
    days: "Dni",
    highlights: "Najważniejsze informacje:",
    bookNow: "Zarezerwuj teraz",
    highlightsLabel: "NAJWAŻNIEJSZE:",
    viewFullDetails: "Zobacz pełne szczegóły",
    viewDetails: "Zobacz szczegóły",
    premiumPackage: "Pakiet Premium",
    arrival: "Przyjazd:",
    route: "Trasa:",
    flights: "Loty:",
    transportation: "Transport:",
    hotels: "Hotele:",
    foodDining: "Jedzenie i wyżywienie:",
    whatsIncluded: "Co obejmuje:",
    attractionsExperiences: "Atrakcje i doświadczenia:",
    itinerary: "Plan podróży:",
    optionalExperiences: "Opcjonalne doświadczenia:",
    availableUponRequest: "Dostępne na żądanie:",
    specialSaharaExperience: "Specjalne doświadczenie Sahary:",
    suitableFor: "Nadaje się do:",
    importantNotes: "Ważne uwagi:",
    priceInformation: "Informacje o cenie:",
    priceWarningText: "Ceny mogą ulec zmianie w zależności od cen lotów, kursów walut, świąt, pór roku i dostępności hotelu.",
    safetyComfort: "Bezpieczeństwo i komfort:",
    safetyText: "Współpracujemy z władzami Maroka i służbami bezpieczeństwa, aby zapewnić bezpieczeństwo i komfort naszych gości.",
    safetyTextBrief: "Dla Twojego bezpieczeństwa skoordynowano działania z władzami Maroka.",
    givesMore: "Maroko Loves You daje więcej:",
    givesMoreText: "Więcej miłości, troski, profesjonalizmu, radości i bezpieczeństwa. Łatwe i relaksujące wycieczki z prawdziwą ludzką gościnnością.",
    givesMoreBrief: "Maroko Cię kocha:",
    givesMoreTextBrief: "Więcej miłości, troski i profesjonalizmu.",
    bookThisPackage: "Zarezerwuj ten pakiet",
    backToPackages: "Powrót do Pakietów",
    premiumMoroccoPackages: "Pakiety Premium Maroko",
    premiumMoroccoPackagesDesc: "Ekskluzywne, starannie dobrane doświadczenia dla naszych wymagających gości.",
    suitable: {
      couples: "Pary",
      families: "Rodziny",
      groups: "Grupy",
      solo: "Podróżujący samotnie",
      seniors: "Seniorzy",
      companies: "Firmy",
      agencies: "Biura podróży",
      operators: "Organizatorzy wycieczek"
    },
    pkg4: {
      title: "LUKSUSOWE DOŚWIADCZENIE MAROKO",
      duration: "16 nocy / 17 dni",
      price: "All inclusive",
      hl1: "Casablanca • Rabat • Fez • Tanger • Szafszawan",
      hl2: "Ifrane • Pustynia Sahara Merzouga",
      hl3: "Essaouira • Góry Ourika i Atlas • Marrakesz",
      hl3_brief: "Odwiedź góry Atlas",
      hl4: "Luksusowy obóz pustynny na 2 noce z wycieczkami na wielbłądach i jeepami",
      hl5: "Magiczny wschód i zachód słońca • Śpij pod gwiazdami",
      subtitle: "✨ Maroko Imperialne i Sahara – pełna podróż (16 nocy / 17 dni)",
      routeText: "Casablanca (1 nocleg), Rabat, Fez (2 noclegi), Tanger (1 nocleg), Szafszawan (1 nocleg), Ifrane (1 nocleg), Merzouga Sahara (2 noclegi), Essaouira (2 noclegi), Ourika i Góry Atlas (1 nocleg), Marrakesz (3 noclegi)",
      inc1: "Hotele 4★ / 5★",
      inc2: "Luksusowy, klimatyzowany obóz pustynny",
      inc2_brief: "Hotele 4-5 gwiazdkowe",
      inc3: "Pełne wyżywienie / Premium kuchnia marokańska",
      inc3_brief: "Profesjonalny przewodnik",
      inc4: "Profesjonalne wielojęzyczne przewodniki",
      inc4_brief: "Specjalne występy na żywo",
      inc5: "Prywatny nowoczesny transport",
      inc5_brief: "Tradycyjne rynki",
      inc6: "Autokary z klimatyzacją",
      inc7: "WiFi • Telewizja • Lodówka na pokładzie",
      inc8: "Prywatny kierowca przez całą trasę",
      inc9: "Wycieczki na wielbłądach",
      inc10: "Doświadczenie pustyni jeepem",
      inc11: "Pokazy folklorystyczne i muzyka na żywo",
      inc12: "Występy tańca marokańskiego",
      inc13: "Warsztaty kulinarne",
      inc14: "Doświadczenia na targowiskach i sukach",
      inc15: "Dywany • Przyprawy • Kwiaty • Tradycyjne rzemiosło",
      inc16: "Jeziora • Rzeki • Góry Atlas",
      inc17: "Specjalne przeżycia wschodu i zachodu słońca",
      inc18: "Bezpośrednie wsparcie 24/7",
      optional1: "Doświadczenie balonem na ogrzane powietrze",
      optional2: "Aktualizacje VIP-ów",
      optional3: "Luksusowe doświadczenia",
      optional4: "Prywatne usługi ochroniarskie",
      optional5: "Usługi pomocy medycznej",
      optionalNote: "Niektóre usługi premium mogą wymagać dodatkowego uczciwego dodatku.",
      sahara1: "Klimatyzowane namioty pustynne premium",
      sahara2: "Atmosfera muzyki przy ognisku",
      sahara3_brief: "Wycieczki jeepem i przejażdżki na wielbłądach",
      itinerary1: "Casablanca – Przyjazd (1 noc)",
      itinerary2: "Rabat – Królewska Stolica",
      itinerary3: "Fez – Maroko duchowe i kulturalne (2 noce)",
      itinerary4: "Tanger – Gdzie Europa spotyka Afrykę (1 noc)",
      itinerary5: "Szafszawan – Błękitna Perła (1 Noc)",
      itinerary6: "Ifrane – Marokańska Szwajcaria (1 noc)",
      itinerary7: "Merzouga Sahara Desert (2 noce) – Luksusowy obóz pustynny – Przejażdżka na wielbłądach – Wycieczki jeepem – Magiczny wschód i zachód słońca – Spanie pod gwiazdami",
      itinerary8: "Essaouira – ucieczka nad Ocean Atlantycki (2 noce)",
      itinerary9: "Góry Ourika i Atlas (1 noc)",
      itinerary10: "Marrakesz – Czerwone Miasto (3 Noce)"
    }
  },
  tourMini: {
    years: "2026 - 2027",
    days: "10 DNI",
    nights: "/ 9 NOCY",
    title: "PREMIUM MAROKO\nWYCIECZKA",
    departures: "WYJAZDY MIESIĘCZNE",
    allIncluded: "WSZYSTKO WLICZONE\nPEŁNE WYŻYWIENIE",
    recommendations: "Zalecenia",
    recCount: "Ponad 500 zadowolonych podróżników"
  },
  testimonials_data: {
    testi1: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Sarah Johnson",
      title: "Londyn, Wielka Brytania",
      text: "Maroko Kocha Dzięki Tobie moja wymarzona podróż stała się rzeczywistością! Każdy szczegół był doskonale zorganizowany, od luksusowych hoteli po autentyczne doświadczenia. Usługa nie ma sobie równych. Już planuję wizytę powrotną!",
      rating: 5
    },
    testi2: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Michaela Chena",
      title: "Singapur",
      text: "Jako podróżujący służbowo byłem pod wrażeniem profesjonalizmu i dostosowania. Opieka VIP od pierwszego dnia, spersonalizowany plan podróży i nienaganna logistyka. Gorąco polecam na podróże dla kadry kierowniczej.",
      rating: 5
    },
    testi3: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Emmę Wilson",
      title: "Sydney, Australia",
      text: "Pustynne doświadczenie było magiczne! Spanie pod gwiazdami, wędrówki na wielbłądach i ciepło marokańskiej gościnności przerosły wszelkie oczekiwania. Dziękujemy za tworzenie wspomnień na całe życie!",
      rating: 5
    },
    testi4: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "Jamesa Rodrigueza",
      title: "Madryt, Hiszpania",
      text: "Planowanie podróży rodzinnej może być stresujące, ale firma Maroko kocha Cię poradziła sobie ze wszystkim znakomicie. Bezpieczna, edukacyjna i zabawna dla wszystkich grup wiekowych. Nasze dzieci wciąż opowiadają o wizytach w Medynie!",
      rating: 5
    },
    testi5: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Anna Mueller",
      title: "Berlinie, Niemcy",
      text: "Doceniam autentyczność kulturową i szacunek okazywany lokalnym tradycjom. Nie była to tylko turystyka; było to prawdziwe zanurzenie się w kulturze. Brawo dla całego zespołu!",
      rating: 5
    },
    testi6: {
      image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e",
      name: "Davida Thompsona",
      title: "Toronto, Kanada",
      text: "Dostępność dla seniorów była wyjątkowa. Wygodne tempo, wspierający przewodnicy i luksusowe zakwaterowanie sprawiły, że moi dziadkowie byli niesamowicie szczęśliwi. Usługa, która naprawdę dba.",
      rating: 5
    },
    testi7: {
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
      name: "Lisę Anderson",
      title: "Nowy Jork, USA",
      text: "Miłośnik jedzenia tutaj! Wrażenia kulinarne były wyśmienite. Każdy posiłek opowiadał jakąś historię, każdy przewodnik okazywał prawdziwą pasję. Smaki Maroka zostaną ze mną na zawsze.",
      rating: 5
    },
    testi8: {
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d",
      name: "Marcusa Smitha",
      title: "Los Angeles, Stany Zjednoczone",
      text: "Pełen przygód i jednocześnie luksusowy – dokładnie to, czego szukałem. Trekking w Atlasie, safari po pustyni, a wszystko to w komforcie VIP. Warte każdego grosza!",
      rating: 5
    },
    testi9: {
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330",
      name: "Zofia Laurent",
      title: "Paryż, Francja",
      text: "Niezwykła romantyczna podróż! Zachód słońca na Saharze, prywatne kolacje z widokiem na Marrakesz i troskliwa obsługa przez cały czas. Maroko Loves You naprawdę zasługuje na swoją nazwę.",
      rating: 5
    },
    intro: "Poznaj naszych zadowolonych gości, którzy poznali Maroko dzięki naszym usługom"
  },
  stats: {
    happyTravelers: "5000+",
    yearsExperience: "15+",
    destinationsCount: "25+",
    satisfactionRate: "98%"
  },
  nav: {
    home: "Dom",
    about: "O nas",
    destinations: "Miejsca docelowe",
    tours: "Wycieczki i pakiety",
    gallery: "Galeria",
    testimonials: "Referencje",
    blog: "Bloga",
    contact: "Skontaktuj się z nami",
    experiences: "Doświadczenia",
    vip: "Biznes VIP",
    vipFull: "Podróże biznesowe VIP",
    worldcup: "Puchar Świata 2030",
    careers: "Kariery",
    chatWhatsApp: "Czatuj na WhatsAppie",
    jewishHeritage: "Koszerna podróż",
    menu: "Menu"
  },
  hero: {
    welcome: "Witamy w Maroku.",
    welcomeHome: "Witamy w domu.",
    subtitle: "Prywatne luksusowe wycieczki, autentyczne przeżycia,",
    subtitleLine2: "i pełna obsługa osobista na terenie Maroka —",
    subtitleGold: "osobiście obsługiwane przez dyrektora generalnego.",
    whatsappBtn: "Porozmawiaj z Ilanem (CEO) teraz na WhatsApp",
    badgeFast: "Szybka reakcja",
    badgePersonal: "Obsługa osobista",
    badge247: "Dostępność 24 godziny na dobę, 7 dni w tygodniu",
    limitedAvail: "Ograniczona dostępność",
    personalizedOnly: "Tylko wycieczki spersonalizowane"
  },
  strip: {
    privateTours: "Wycieczki prywatne",
    localExperts: "Lokalni eksperci",
    bestHotels: "Najlepsze hotele",
    luxuryTransport: "Luksusowy transport",
    satisfaction: "100% satysfakcji"
  },
  cta: {
    whatsapp: "Porozmawiaj z Ilanem (CEO) teraz na WhatsApp",
    whatsappFloating: "Czatuj na WhatsAppie",
    whatsappInquiry: "Witam, jestem zainteresowany luksusowymi wrażeniami z podróży do Maroka."
  },
  home: {
    vipBannerTitle: "Doświadczenia podróżnicze VIP Maroko",
    vipBannerText: "Ekskluzywny dostęp, prywatni kierowcy i luksusowe zakwaterowanie dostosowane do potrzeb wymagających podróżników.",
    vipBannerBtn: "Odkryj usługi VIP",
    wcBadge: "🇲🇦Puchar Świata w Maroku 2030",
    wcTitle: "Maroko 2030",
    wcText: "Ekskluzywne pakiety podróżne na Mistrzostwa Świata łączące piłkę nożną, kulturę marokańską, gościnność VIP i luksusowe doświadczenia.",
    wcBtn: "Zobacz pakiety",
    galleryTitle: "Galeria",
    gallerySubtitle: "Rzut oka na Twoją przyszłą marokańską podróż",
    exploreDestination: "Poznaj miejsce docelowe",
    featuredToursTitle: "Polecane wycieczki i pakiety",
    featuredToursSubtitle: "Starannie dobrane doświadczenia zapewniające idealną marokańską przygodę",
    viewAllTours: "Zobacz wszystkie wycieczki",
    culinaryTitle: "Nasze jedzenie - najlepsze na świecie",
    culinarySubtitle: "Poznaj marokańską doskonałość kulinarną 🍲",
    culinaryBtn: "Odkryj doznania kulinarne",
    culinaryIntro: "W Maroko Loves You jedzenie to nie tylko jedzenie. To podróż do serca kultury marokańskiej. Oferujemy autentyczne, starannie wyselekcjonowane doznania kulinarne — od tradycyjnych domowych posiłków po wysokiej klasy kuchnię marokańską, a wszystko to przygotowane z miłością i z najświeższych lokalnych składników.",
    culinaryVideoTitle: "Filmy z przeżyciami kulinarnymi",
    culinaryFeatures: [
      "Tradycyjne tagines",
      "Autentyczny kuskus",
      "Marokańskie ciasta",
      "Ceremonie herbaty",
      "Lekcje gotowania",
      "Lokalne przyprawy",
      "Składniki organiczne",
      "Domowe posiłki"
    ],
    videoTitle: "ZALECENIA",
    unityQuote: "Maroko Loves You wita wszystkie kultury, wszystkie wierzenia i wszystkie narody.",
    unityAlt: "Maroko kocha cię sztandar jedności",
    testimonialsTitle: "Co mówią nasi goście VIP",
    testimonialsSubtitle: "Prawdziwe recenzje od międzynarodowych podróżników",
    readMoreReviews: "Przeczytaj więcej recenzji",
    viewAllTransport: "Wyświetl wszystkie Transport",
    transportTitle: "Nasz transport i kierowcy VIP",
    transportSubtitle: "Luksus, komfort i bezpieczeństwo w całym Maroku 🌍",
    transportIntro: "W firmie Maroko Loves You transport nie ogranicza się tylko do przemieszczania się z jednego miejsca do drugiego. To część doświadczenia. Zapewniamy nowoczesne, czyste, wygodne i w pełni klimatyzowane pojazdy na terenie całego Maroka — z profesjonalnymi kierowcami, serdeczną gościnnością i obsługą VIP od pierwszej chwili."
  },
  destinations: {
    pageTitle: "Poznaj kierunki Maroka",
    pageSubtitle: "Odkryj niesamowite miejsca do odwiedzenia w pięknym Maroku",
    sectionTitle: "Wszystkie miejsca docelowe",
    sectionIntro: "Maroko to kraj różnorodnych krajobrazów i bogatego dziedzictwa kulturowego. Poznaj nasze starannie wybrane kierunki:",
    exploreNow: "Przeglądaj teraz",
    ctaTitle: "Gotowy do zaplanowania podróży?",
    ctaText: "Przejrzyj nasze wybrane wycieczki i pakiety, aby znaleźć idealne marokańskie przeżycie",
    ctaBtn: "Zobacz wycieczki i pakiety"
  },
  experiences: {
    pageTitle: "Marokańska doskonałość kulinarna",
    pageSubtitle: "Odkryj naszą żywność — najlepszą na świecie",
    bookViaWhatsApp: "Zarezerwuj przez WhatsApp",
    introTitle: "Nasze wyjątkowe marokańskie doświadczenie kulinarne",
    introHighlight: "Autentyczne smaki, świeże składniki, wielowiekowa tradycja i niezapomniana gościnność.",
    introP1: "Zapraszamy do autentycznych smaków Maroka.",
    introP2: "W Maroko Loves You jedzenie to nie tylko posiłek — to kultura, historia, rodzina, gościnność i miłość.",
    introP3: "Kuchnia marokańska od wieków uznawana jest za jedną z najbogatszych, najzdrowszych i najbardziej aromatycznych kuchni świata.",
    introP4: "Nasze tradycje kulinarne łączą wpływy arabskie, berberyjskie, żydowskie, marokańskie, andaluzyjskie, śródziemnomorskie i afrykańskie – tworząc unikalne przepisy zachowane od ponad 500 lat.",
    prepTitle: "Sztuka przygotowania marokańskiego",
    prepP1: "Wszystko przygotowywane jest z troską, pasją, świeżymi, lokalnymi składnikami i autentycznymi marokańskimi przyprawami.",
    prepP2: "Starannie wybieramy dla naszych gości zaufane restauracje, autentyczne lokalne doświadczenia i wysokiej jakości miejsca kulinarne.",
    prepP3: "Maroko jest znane na całym świecie ze swoich kolorowych rynków, świeżego rolnictwa, produktów naturalnych, przypraw, oliwek, pomarańczy, ciastek, herbaty miętowej i niezapomnianej gościnności.",
    journeyVideos: "Filmy z podróży kulinarnych",
    highlightsTitle: "Tradycyjne atrakcje kulinarne",
    highlightTagine: "Autentyczny marokański tagine",
    highlightCouscous: "Tradycyjny kuskus",
    highlightVegetables: "Świeże warzywa i naturalne składniki",
    highlightPastries: "Domowe wypieki i desery",
    highlightBreakfasts: "Tradycyjne marokańskie śniadania",
    highlightMeat: "Świeże ryby i wysokiej jakości mięsa",
    highlightJuices: "Naturalne soki i marokańska herbata",
    highlightHealthy: "Zdrowe i smaczne tradycje kulinarne",
    galleryTitle: "Nasza galeria kulinarna",
    summaryP1: "Naszym celem jest zaoferowanie naszym gościom nie tylko wycieczki, ale prawdziwej marokańskiej podróży kulinarnej.",
    tagHealthy: "Zdrowy",
    tagAuthentic: "Autentyczny",
    tagTraditional: "Tradycyjny",
    tagFresh: "Świeży",
    tagUnique: "Wyjątkowy",
    tagDelicious: "Pyszne",
    important: "Ważne:",
    guidanceNote: "Aby uzyskać najlepsze doznania kulinarne, zdecydowanie zalecamy przestrzeganie wskazówek naszego zespołu i zaleceń kulinarnych podczas podróży po Maroku.",
    whereMeal: "Gdzie każdy posiłek staje się wspomnieniem.",
    whatsappLabel: "WhatsApp: +972 54-633-8757",
    moroccoLine: "Linia Maroko: +212 6 63 63 05 79"
  },
  vip: {
    pageTitle: "Podróże VIP i biznesowe",
    pageSubtitle: "Ekskluzywne usługi dla dyrektorów generalnych, inwestorów i wymagających podróżników",
    introTitle: "Bezproblemowa doskonałość w Maroku",
    introText: "MarokoLovesYou zapewnia niezrównany standard usług dla osób podróżujących służbowo, delegacji korporacyjnych i gości VIP. Rozumiemy, że Twój czas jest cenny, a Twoje standardy są bezkompromisowe. Od przylotu do odlotu, zajmujemy się każdym szczegółem z precyzją, dzięki czemu możesz skupić się na celach biznesowych, a my zapewniamy nieskazitelne marokańskie doświadczenie.",
    ctaTitle: "Bezpośredni dostęp do dyrektora generalnego",
    ctaText: "W przypadku pilnych zapytań i wysoce specjalistycznych wniosków należy porozmawiać bezpośrednio z naszym założycielem i dyrektorem generalnym, Ilanem Hatchuelem.",
    ctaBtn: "Skontaktuj się teraz z Ilanem",
    luxuryTransport: "Luksusowy transport",
    luxuryTransportDesc: "Transfery lotniskowe VIP i prywatni dwujęzyczni kierowcy dostępni 24 godziny na dobę, 7 dni w tygodniu w luksusowych pojazdach (Mercedes Klasa S, Klasa V).",
    premiumAccom: "Zakwaterowanie premium",
    premiumAccomDesc: "Ekskluzywne rezerwacje w hotelach pięciogwiazdkowych, luksusowych riadach lub prywatnych willach dla kadry kierowniczej i jej zespołów.",
    businessConcierge: "Konsjerż biznesowy",
    businessConciergeDesc: "Pełna pomoc w spotkaniach, rezerwacje prywatnych posiłków i specjalistyczne plany wycieczek dla firm.",
    securityPrivacy: "Bezpieczeństwo i prywatność",
    securityPrivacyDesc: "Dyskretna obsługa, bezpieczne środowisko i absolutna poufność dla znanych osobistości i celebrytów.",
    support247: "Wsparcie 24/7",
    support247Desc: "Bezpośredni kontakt z Prezesem i dedykowanym zespołem gotowym do pomocy w każdym momencie pobytu.",
    customItineraries: "Niestandardowe trasy",
    customItinerariesDesc: "Dostosowane plany podróży doskonale równoważą Twoje obowiązki biznesowe z najwyższej jakości marokańskimi doświadczeniami kulturalnymi."
  },
  worldcup: {
    pageTitle: "Puchar Świata Maroko 2030",
    pageSubtitle: "Ekskluzywne pakiety VIP i przeżycia podróżnicze na największe wydarzenie piłkarskie",
    limitedBadge: "Ograniczona dostępność",
    introTitle: "Najwspanialsza podróż piłkarska",
    introText: "W 2030 r. Maroko będzie współgospodarzem Mistrzostw Świata FIFA, przenosząc najbardziej prestiżowe wydarzenie sportowe na świecie do Afryki Północnej. MarokoLovesYou z dumą oferuje ekskluzywne, luksusowe pakiety podróżne all-inclusive zaprojektowane dla fanów, którzy oczekują absolutnie najlepszego komfortu, dostępu i wrażeń.",
    packagesTitle: "Pakiety premium na Puchar Świata",
    silverTitle: "Pakiet Srebrny",
    silverSub: "Niezbędne doświadczenie",
    goldTitle: "Pakiet Złoty",
    goldSub: "Luksusowe doświadczenie",
    mostPopular: "Najpopularniejsze",
    diamondTitle: "Diamentowy VIP",
    diamondSub: "Najlepsze doświadczenie",
    inquireWhatsApp: "Zapytaj przez WhatsApp",
    ctaTitle: "Zabezpiecz swoje miejsce, zanim ceny wzrosną",
    ctaText: "Ze względu na niezwykle duży popyt międzynarodowy, zdecydowanie zalecamy wcześniejsze zabezpieczenie pakietu VIP. Miejsca noclegowe w miastach gospodarzach zostaną wyprzedane.",
    ctaBtn: "Skontaktuj się z nami już dziś",
    silverF1: "Zakwaterowanie w riadzie premium / hotelu 4-gwiazdkowym",
    silverF2: "Zaplanowana wcześniej logistyka dnia meczowego",
    silverF3: "Wycieczki po miastach z przewodnikiem (miasta-gospodarze)",
    silverF4: "Dedykowana linia wsparcia 24/7",
    goldF1: "Zakwaterowanie w 5-gwiazdkowym hotelu/luksusowej willi",
    goldF2: "Prywatne lotnisko i transfery na mecze",
    goldF3: "Wycieczka VIP do obozu pustynnego (2 dni)",
    goldF4: "Osobisty dwujęzyczny konsjerż",
    diamondF1: "Apartamenty Prezydenckie / Prywatne Pałace",
    diamondF2: "Prywatny szofer i ochrona 24 godziny na dobę, 7 dni w tygodniu",
    diamondF3: "Ekskluzywny dostęp do wydarzeń i przyjęć VIP",
    diamondF4: "Bezpośredni dyrektor generalny ds. obsługi i konsjerż VVIP"
  },
  gallery: {
    pageTitle: "Nasza galeria",
    pageSubtitle: "Wizualne wspomnienia niezapomnianych marokańskich podróży",
    picturesTitle: "Maroko na zdjęciach",
    picturesIntro: "Zapoznaj się z naszą kolekcją zapierających dech w piersiach zdjęć z Maroka",
    videosTitle: "Maroko w ruchu",
    videosIntro: "Poznaj Maroko dzięki naszej kolekcji filmów",
    catFood: "Doświadczenie kulinarne",
    catDestinations: "Miejsca docelowe",
    catKosher: "Koszerne",
    catTransport: "Transport VIP"
  },
  testimonials: {
    pageTitle: "Świadectwa gości",
    pageSubtitle: "Przeczytaj, co nasi podróżnicy mają do powiedzenia na temat swoich wrażeń z Maroka",
    sectionTitle: "Nasi szczęśliwi podróżnicy",
    sectionIntro: "Tysiące zadowolonych gości doświadczyło z nami magii Maroka",
    verifiedGuest: "Zweryfikowany gość",
    ratingsTitle: "Nasze oceny",
    avgRating: "Średnia ocena",
    verifiedReviews: "Zweryfikowane recenzje",
    fromReal: "Od prawdziwych podróżników",
    custSatisfaction: "Zadowolenie klienta",
    wouldRecommend: "Polecam",
    shareTitle: "Podziel się swoim doświadczeniem",
    shareText: "Miałeś z nami niesamowitą podróż? Chętnie o tym usłyszymy!",
    shareBtn: "Opowiedz nam swoją historię"
  },
  blog: {
    pageTitle: "Blog podróżniczy",
    pageSubtitle: "Historie, porady i przewodniki dotyczące marokańskiej przygody",
    sectionTitle: "Najnowsze artykuły podróżnicze",
    sectionIntro: "Przeczytaj nasze najnowsze artykuły na temat podróżowania po Maroku, lokalnej kulturze i poufnych poradach",
    readMore: "Czytaj więcej →",
    by: "Przez",
    newsletterTitle: "Zapisz się na nasz newsletter",
    newsletterText: "Otrzymuj najnowsze wskazówki dotyczące podróży i ekskluzywne oferty prosto na swoją skrzynkę odbiorczą",
    newsletterPlaceholder: "Wpisz swój adres e-mail",
    subscribe: "Subskrybuj"
  },
  contact: {
    pageTitle: "Skontaktuj się z nami 24 godziny na dobę, 7 dni w tygodniu",
    pageSubtitle: "Skontaktuj się z naszym zespołem, aby zaplanować swoją przygodę VIP w Maroku",
    getInTouch: "Skontaktuj się z nami",
    getInTouchText: "Jesteśmy tutaj, aby Ci pomóc i odpowiedzieć na wszelkie pytania. Nasz zespół jest gotowy pomóc Ci w zaplanowaniu idealnej podróży do Maroka.",
    address: "Nasz adres",
    addressText: "53 Mohammed V Street, Fez, Maroko",
    phone: "Numery telefonów 📞",
    directPhone: "Telefon bezpośredni: +212 6 63 63 05 79",
    whatsappPhone: "WhatsApp: +972 54 633 8757",
    email: "Profesjonalne adresy e-mail",
    emailList: [
      "CEO@MoroccoLovesYou.com",
      "Info@MoroccoLovesYou.com",
      "Sales@MoroccoLovesYou.com",
      "Michael@MoroccoLovesYou.com",
      "Kim@MoroccoLovesYou.com"
    ],
    businessHours: "Godziny otwarcia",
    businessHoursText: "Dostępny 24 godziny na dobę, 7 dni w tygodniu\n7 dni w tygodniu",
    responseTime: "Skontaktujemy się z Tobą w ciągu 48 godzin.",
    welcomeMessage: "Witamy w Maroku 🇲🇦",
    followUs: "Śledź nas",
    formTitle: "Wyślij nam wiadomość",
    successMessage: "✓ Dziękuję! Wkrótce się z Tobą skontaktujemy.",
    firstName: "Imię",
    lastName: "Nazwisko",
    emailAddress: "Adres e-mail",
    phoneNumber: "Numer telefonu",
    subject: "Temat",
    selectSubject: "Wybierz temat",
    tourInquiry: "Zapytanie o wycieczkę",
    bookingQuestion: "Pytanie dotyczące rezerwacji",
    customPackage: "Pakiet niestandardowy",
    feedback: "Informacje zwrotne",
    other: "Inne",
    message: "Szczegóły / Wiadomość",
    sendMessage: "Wyślij wiadomość",
    mapTitle: "Znajdź nas na mapie",
    faqTitle: "Często zadawane pytania",
    faq1Q: "Jaki jest najlepszy czas na wizytę w Maroku?",
    faq1A: "Wiosna (kwiecień-maj) i jesień (wrzesień-październik) oferują najlepszą pogodę. Lato na pustyni jest gorące, a zima łagodna, ale może być deszczowa.",
    faq2Q: "Czy potrzebuję wizy, aby odwiedzić Maroko?",
    faq2A: "Wymagania wizowe zależą od Twojej narodowości. Do wielu krajów obowiązuje ruch bezwizowy na okres do 90 dni. Skontaktuj się z lokalną ambasadą.",
    faq3Q: "Jaka waluta jest używana w Maroku?",
    faq3A: "Dirham marokański (MAD) jest oficjalną walutą. Bankomaty są powszechnie dostępne w miastach, a większość miejsc akceptuje karty kredytowe.",
    faq4Q: "Jakim językiem mówi się w Maroku?",
    faq4A: "Arabski i berberyjski (Amazigh) są językami urzędowymi. Francuski jest powszechnie używany, a angielski jest coraz bardziej powszechny w obszarach turystycznych.",
    faq5Q: "Czy Maroko jest bezpieczne dla turystów?",
    faq5A: "Tak, Maroko jest ogólnie bezpieczne dla turystów. Obowiązują zdroworozsądkowe środki ostrożności. Nasi przewodnicy zapewnią Państwu bezpieczną i przyjemną przygodę.",
    faq6Q: "Czy mogę dostosować swój pakiet wycieczek?",
    faq6A: "Absolutnie! Oferujemy niestandardowe pakiety dostosowane do Twoich zainteresowań, budżetu i dat podróży. Skontaktuj się z nami, aby omówić Twoje wymagania."
  },
  about: {
    pageTitle: "O MarokoLovesYou",
    pageSubtitle: "Twój zaufany partner w odkrywaniu magii Maroka",
    storyTitle: "Nasza historia",
    storyP1: "MarokoLovesYou zostało założone z prostą misją: pomóc podróżnym doświadczyć autentycznego piękna, kultury i gościnności Maroka. To, co zaczęło się jako mała firma świadcząca usługi przewodników turystycznych, przekształciło się w kompleksową firmę turystyczną obsługującą tysiące turystów rocznie.",
    storyP2: "Nasza założycielka, Fatima Hassan, zakochała się w Maroku i zapragnęła podzielić się tą pasją ze światem. Dziś jesteśmy dumni z tworzenia spersonalizowanych, autentycznych doświadczeń, które wykraczają poza typową turystykę.",
    missionTitle: "🎯 Nasza misja",
    missionText: "Zapewnianie wyjątkowych wrażeń z podróży, które prezentują bogate dziedzictwo kulturowe Maroka, wspaniałe krajobrazy i ciepłą gościnność, przy jednoczesnym wspieraniu lokalnych społeczności i praktyk zrównoważonej turystyki.",
    visionTitle: "🌟 Nasza wizja",
    visionText: "Być wiodącą firmą turystyczną w Maroku, znaną z autentyczności, niezawodności i tworzenia niezapomnianych wspomnień dla każdego podróżnika, który zdecyduje się odkrywać z nami ten wspaniały kraj.",
    whyTitle: "Dlaczego warto wybrać MarokoLovesYou?",
    expertTitle: "Wiedza ekspercka",
    expertText: "Nasz zespół posiada rozległą wiedzę na temat Maroka i zapewnia spersonalizowane rekomendacje.",
    localTitle: "Połączenia lokalne",
    localText: "Współpracujemy z autentycznymi lokalnymi przewodnikami i rodzinami, aby zapewnić autentyczne doświadczenia.",
    valueTitle: "Najlepsza wartość",
    valueText: "Konkurencyjne ceny bez uszczerbku dla jakości i doświadczenia.",
    safetyTitle: "Bezpieczeństwo i wsparcie",
    safetyText: "W cenie całodobowa obsługa klienta i kompleksowe ubezpieczenie podróżne.",
    sustainTitle: "Zrównoważona turystyka",
    sustainText: "Wspieramy społeczności lokalne i uprawiamy odpowiedzialną turystykę.",
    bookingTitle: "Łatwa rezerwacja",
    bookingText: "Prosty proces rezerwacji online z elastycznymi opcjami płatności.",
    teamTitle: "Nasz zespół",
    teamSubtitle: "Poznaj pełnych pasji ludzi stojących za MarokoLovesYou",
    happyTravelers: "Szczęśliwi podróżnicy",
    yearsExp: "Lata doświadczenia",
    destinationsCount: "Miejsca docelowe",
    satisfactionRate: "Wskaźnik satysfakcji"
  },
  footer: {
    description: "Odkryj z nami magię Maroka. Przeżyj niezapomniane przygody i twórz trwałe wspomnienia.",
    quickLinks: "Szybkie linki",
    more: "Więcej",
    contactInfo: "Informacje kontaktowe",
    copyright: "© 2024 MarokoLovesYou. Wszelkie prawa zastrzeżone."
  },
  starBanner: {
    ceoMessage: "WIADOMOŚĆ DYREKTORA",
    watchVideo: "Obejrzyj mój film",
    readMessage: "i przeczytaj moją wiadomość",
    getToKnow: "Poznaj",
    ilanPersonally: "Ilan osobiście"
  },
  cityDetail: {
    notFound: "Nie znaleziono miasta",
    backHome: "Powrót do domu",
    discoverSubtitle: "Odkryj piękno i kulturę",
    planTrip: "Zaplanuj moją podróż do",
    galleryOf: "Galeria",
    bookExperience: "Zarezerwuj to doświadczenie",
    requestItinerary: "Poproś o pełny plan podróży",
    readyToVisit: "Gotowy do odwiedzenia",
    readyToVisitText: "Pozwól nam zaplanować Twoją idealną podróż do tego niesamowitego miejsca",
    planMyTrip: "Zaplanuj moją podróż",
    talkExpert: "Porozmawiaj z ekspertem"
  },
  transportation: {
    pageTitle: "Transport VIP i kierowcy",
    pageSubtitle: "Luksus, komfort i bezpieczeństwo w całym Maroku",
    introTitle: "Nasz transport i kierowcy VIP",
    introP1: "W firmie Maroko Loves You transport nie ogranicza się tylko do przemieszczania się z jednego miejsca do drugiego.",
    introP2: "To część doświadczenia.",
    introP3: "Zapewniamy nowoczesne, czyste, wygodne i w pełni klimatyzowane pojazdy na terenie całego Maroka — z profesjonalnymi kierowcami, serdeczną gościnnością i obsługą VIP od pierwszej chwili.",
    introP4: "Niezależnie od tego, czy podróżujesz w parze, z rodziną, delegacją biznesową czy grupą prywatną, zadbamy o to, aby Twoja podróż była bezpieczna, relaksująca i niezapomniana.",
    servicesTitle: "Nasze usługi transportowe obejmują",
    servicesList: [
      "Nowoczesne autobusy VIP",
      "Luksusowe minibusy",
      "Samochody prywatne",
      "Jeepy 4x4 na pustynne przygody",
      "Limuzyny VIP",
      "Odbiór i dowóz na lotnisko",
      "Profesjonalni wielojęzyczni kierowcy",
      "Wygodna klimatyzacja",
      "Czyste i zorganizowane pojazdy",
      "Lodówki w wybranych pojazdach",
      "Systemy telewizyjne i rozrywkowe",
      "Muzyka podczas podróży",
      "Bezpieczna i płynna jazda",
      "Pomoc 24/7 w całym Maroku"
    ],
    featureList: [
      "Nowoczesne autobusy VIP",
      "Luksusowe minibusy",
      "Samochody prywatne",
      "Jeepy 4x4",
      "Odbiór z lotniska",
      "Wielojęzyczne sterowniki",
      "Pomoc 24/7",
      "Bezpieczna jazda"
    ],
    driversTitle: "Poznaj naszych kierowców",
    driversText1: "Nasi kierowcy są częścią rodziny Maroko Loves You.",
    driversText2: "Profesjonalny, pełen szacunku, doświadczony i zawsze gotowy do pomocy z uśmiechem.",
    driversText3: "Wielu naszych kierowców mówi wieloma językami i doskonale zna Maroko, dzięki czemu nasi goście czują się komfortowo, bezpiecznie i pozostają w kontakcie przez całą podróż.",
    safetyTitle: "Bezpieczeństwo i wygoda przede wszystkim",
    safetyText1: "Twój komfort i bezpieczeństwo są dla nas najważniejsze.",
    safetyText2: "Wszystkie pojazdy są regularnie konserwowane, czyszczone i starannie przygotowywane przed każdą podróżą.",
    safetyText3: "Współpracujemy wyłącznie z zaufanymi zawodowymi kierowcami i wysokiej jakości partnerami transportowymi.",
    categories: {
      buses: "Autobusy VIP",
      minibuses: "Luksusowe minibusy",
      cars: "Prywatne samochody i transfery VIP",
      jeeps: "Jeepy 4x4 i transport pustynny",
      meetDrivers: "Poznaj naszych kierowców",
      videos: "Filmy z doświadczeniami związanymi z transportem"
    },
    videoGalleryTitle: "Filmy z przeżyciami VIP",
    ctaTitle: "Gotowy na wygodne zwiedzanie Maroka?",
    ctaSubtitle: "Porozmawiaj bezpośrednio z Allanem – dyrektorem generalnym i założycielem",
    whatsapp: "WhatsApp: +972546338757",
    moroccoLine: "Linia bezpośrednia w Maroku: +212 6 63 63 05 79"
  },
  jewishHeritage: {
    pageTitle: "Luksusowe koszerne wycieczki po Maroku",
    pageSubtitle: "Autentyczne dziedzictwo żydowskie, w 100% koszerna kuchnia, luksusowa gościnność i wyjątkowe doświadczenia Maroka.",
    introTitle: "Luksusowe doświadczenie dziedzictwa żydowskiego",
    introHeading: "Odkryj autentyczne żydowskie Maroko",
    introText: "Odkryj głębokie korzenie historii Żydów w Maroku dzięki eleganckiej, autentycznej i najwyższej jakości podróży. Specjalizujemy się w zapewnianiu płynnej podróży społecznościom żydowskim na całym świecie, koncentrując się na dziedzictwie, połączeniach i absolutnym komforcie.",
    introQuote: "„Maroko to kraina tolerancji i współistnienia, w której dziedzictwo żydowskie jest chronione z miłością i szacunkiem”.",
    experiencesTitle: "Nasze koszerne doświadczenia obejmują",
    experiencesList: [
      "100% koszerna żywność i restauracje",
      "Dostępny prywatny koszerny szef kuchni",
      "Tradycyjna marokańska kuchnia żydowska",
      "Luksusowe hotele 4 i 5-gwiazdkowe",
      "Prywatny transport VIP",
      "Wielojęzyczne profesjonalne przewodniki",
      "Zwiedzanie dziedzictwa żydowskiego i synagogi",
      "Cmentarze i muzea żydowskie",
      "Doświadczenia na Saharze i w łaźni tureckiej",
      "Profesjonalna pomoc 24 godziny na dobę, 7 dni w tygodniu"
    ],
    expFood: "100% koszerne jedzenie",
    expRestaurant: "Koszerna restauracja",
    expChef: "Dostępny prywatny koszerny szef kuchni",
    expCuisine: "Tradycyjna marokańska kuchnia żydowska",
    expHotels: "Luksusowe hotele 4 i 5 gwiazdek",
    expDeluxeHotels: "Hotele Deluxe dostępne na życzenie",
    expTransport: "Prywatny transport VIP",
    expDrivers: "Kierowcy zawodowi",
    expAC: "Pojazdy klimatyzowane",
    expWifi: "Wi-Fi, telewizor i lodówki w wybranych pojazdach",
    expGuides: "Wielojęzyczne profesjonalne przewodniki",
    expStaff: "Personel mówiący po hebrajsku / angielsku / francusku / hiszpańsku / rosyjsku / niemiecku",
    expHeritage: "Wycieczki po dziedzictwie żydowskim",
    expSynagogues: "Starożytne synagogi",
    expCemeteries: "Cmentarze żydowskie",
    expMuseums: "Muzea Żydowskie",
    expSpiritual: "Doświadczenia duchowe i kulturowe",
    expDesert: "Doświadczenia na Saharze",
    expHammam: "Doświadczenia marokańskiej łaźni tureckiej",
    expAttractions: "Wyjątkowe atrakcje w całym Maroku",
    expAssistance: "Pomoc 24/7",
    packagesTitle: "Elastyczne koszerne pakiety podróżne",
    packagesIntro: "Każdą wycieczkę dostosowujemy do potrzeb, tradycji, stylu podróżowania, terminów i oczekiwań naszych gości.",
    packageOptions: [
      "4–5 dni",
      "7–8 dni",
      "10–11 dni",
      "13–14 dni",
      "21 dni",
      "Prywatne wycieczki szyte na miarę"
    ],
    package4_5: "4–5 dni",
    package7_8: "7–8 dni",
    package10_11: "10–11 dni",
    package13_14: "13–14 dni",
    package21: "21 dni",
    packageTailor: "Prywatne wycieczki szyte na miarę",
    packagesQuote: "„Każdy wyjazd dostosowujemy do potrzeb, tradycji, stylu podróżowania, terminów i oczekiwań naszych gości.”",
    safetyTitle: "Wygodna, profesjonalna i bezpieczna podróż",
    safetyText: "Nasze wycieczki działają z dużą dbałością o komfort, organizację, jakość usług i profesjonalną koordynację w całym Maroku.",
    safetyQuote: "„Nasze wycieczki kładziemy duży nacisk na komfort, organizację, jakość usług i profesjonalną koordynację na terenie Maroka”.",
    b2bTitle: "Żydowskie partnerstwa turystyczne B2B",
    b2bText: "Współpracujemy ze społecznościami żydowskimi, synagogami, rabinami i organizatorami wycieczek koszernych na całym świecie, aby tworzyć znaczące podróże po dziedzictwie.",
    b2bPartnersList: "Współpracujemy z: gminami żydowskimi, synagogami, rabinami, organizacjami żydowskimi, organizatorami wycieczek koszernych i biurami podróży na całym świecie.",
    partnerBtn: "Współpracuj z nami",
    galleryTitle: "Galeria Doświadczeń Koszernych",
    videosTitle: "Polecane filmy",
    ctaTitle: "Gotowy do rozpoczęcia podróży?",
    msgAllan: "Wyślij wiadomość do Allana na WhatsApp",
    callMorocco: "Zadzwoń do Maroka: +212 6 63 63 05 79",
    ceoContact: "Porozmawiaj z Allanem Hatchuelem bezpośrednio na WhatsApp",
    exploreBtn: "Poznaj wycieczki koszerne"
  },
  aria: {
    selectLanguage: "Wybierz język",
    closeDetails: "Zamknij szczegóły",
    openMenu: "Otwórz menu",
    closeMenu: "Zamknij menu",
    kosherTravel: "Koszerne podróże Maroko",
    watchVideo: "Obejrzyj film Magiczne Maroko",
    followInstagram: "Śledź nas na Instagramie",
    followFacebook: "Śledź nas na Facebooku",
    ceoMessage: "Dyrektor generalny Maroka cię kocha",
    whatsappSocial: "WhatsApp",
    instagramSocial: "Instagrama",
    facebookSocial: "Facebooku",
    logoAlt: "MarokoLovesYou logo",
    kingAlt: "Król Maroka",
    kosherOptionsAlt: "Opcje koszerne",
    moroccoLandscape: "Krajobraz Maroka",
    worldCupAlt: "Trofeum Pucharu Świata z flagą Maroka",
    b2bBannerAlt: "Baner wycieczki wyłącznie B2B — kliknij, aby przejść do WhatsApp",
    starAlt: "Gwiazda",
    playVideo: "Zagraj",
    pauseVideo: "Pauza",
    vipBus: "Autobus VIP",
    drivers: "Nasi kierowcy",
    jewishHeritageArchitecture: "Architektura dziedzictwa żydowskiego",
    jewishHeritageMorocco: "Dziedzictwo żydowskie Maroko",
    kosherFoodMorocco: "Koszerne jedzenie Maroko",
    jewishHeritageExperience: "Doświadczenie dziedzictwa żydowskiego",
    kosherMoroccanTable: "Koszerny stół marokański",
    luxuryHospitality: "Luksusowa gościnność",
    kosherExperience: "Koszerne doświadczenie"
  },
  forms: {
    firstName: "np. Jan",
    lastName: "np. Łania",
    email: "nazwa@przykład.com",
    subject: "Jak możemy pomóc?",
    message: "Opowiedz nam więcej o swoich planach podróżniczych...",
    phone: "Twój numer telefonu",
    date: "Wybierz datę",
    guests: "Liczba gości"
  },
  common: {
    selectLanguage: "Wybierz język",
    instagram: "Instagrama",
    facebook: "Facebooku",
    loading: "Ładowanie...",
    error: "Wystąpił błąd",
    success: "Sukces!",
    noResults: "Nie znaleziono żadnych wyników",
    viewMore: "Zobacz więcej",
    viewLess: "Zobacz Mniej",
    bookNow: "Zarezerwuj teraz",
    learnMore: "Dowiedz się więcej",
    contactUs: "Skontaktuj się z nami",
    close: "Zamknij",
    back: "Powrót",
    next: "Następny",
    previous: "Poprzedni",
    search: "Szukaj...",
    filter: "Filtruj",
    sort: "Sortuj",
    price: "Cena",
    duration: "Czas trwania",
    languages: {
      english: "Angielski",
      american: "Amerykanin",
      australia: "Australii",
      canada: "Kanada",
      french: "Francuski",
      spanish: "Hiszpański",
      hebrew: "hebrajski",
      arabic: "العربية",
      german: "niemiecki",
      italian: "włoski",
      japanese: "Japoński",
      chinese: "chiński",
      korean: "koreański",
      vietnamese: "wietnamski",
      russian: "Rosyjski",
      en: "Angielski",
      "en-US": "Amerykanin",
      "en-AU": "Australii",
      "en-CA": "Kanada",
      fr: "Francuski",
      es: "Hiszpański",
      he: "hebrajski",
      ar: "العربية",
      de: "niemiecki",
      it: "włoski",
      ja: "Japoński",
      zh: "chiński",
      ko: "koreański",
      vi: "wietnamski",
      ru: "Rosyjski",
      pl: "Polski"
    }
  },
  whatsapp: {
    greeting: "Cześć Maroko Cię kocha! 🌟",
    bookPackage: "Chcę zarezerwować następujący pakiet:",
    packageInfo: "📦 Pakiet: ",
    duration: "⏱️Czas trwania: ",
    price: "💰 Cena: ",
    bookingRequest: "Proszę o informację o dostępności i dalszych krokach. Dziękuję!",
    cityTrip: "Chciałbym zaplanować wycieczkę do {city}. Czy możesz mi pomóc?",
    silverPackage: "Interesuje mnie Pakiet Srebrny Puchar Świata",
    goldPackage: "Jestem zainteresowany Złotym Pakietem Pucharu Świata",
    diamondPackage: "Interesuje mnie Pakiet VIP Diamentowy Puchar Świata",
    worldCupSecure: "Witam, chcę zapewnić sobie miejsce na Maroko 2030.",
    kosherInquiry: "Jestem zainteresowany Twoimi pakietami podróżniczymi Koszerne Maroko.",
    customPackage: "Chciałbym stworzyć niestandardowy pakiet dla naszej grupy.",
    businessInquiry: "Jestem zainteresowany usługami VIP Business Travel."
  },
  blog_posts: {
    post1: {
      title: "10 ukrytych klejnotów do odkrycia w Maroku",
      author: "Fatima Hassan",
      date: "15 marca 2024 r",
      category: "Przewodnik turystyczny",
      excerpt: "Odkryj mniej znane miejsca i ukryte skarby Maroka, za którymi tęskni większość turystów. Od tajnych górskich wiosek po dziewicze obszary przybrzeżne – odkryj autentyczne Maroko.",
      content: "Maroko to znacznie więcej niż tylko Marakesz i Casablanca. Ten obszerny przewodnik odkrywa ukryte skarby..."
    },
    post2: {
      title: "Najlepszy czas na wizytę w Maroku: kompletny przewodnik",
      author: "Ahmeda Bennaniego",
      date: "10 marca 2024 r",
      category: "Planowanie",
      excerpt: "Planujesz podróż do Maroka? Dowiedz się, jakie są najlepsze pory roku do odwiedzenia, czego się spodziewać w zależności od pogody i jak najlepiej wykorzystać podróż przez cały rok.",
      content: "Wybór odpowiedniego czasu na wizytę w Maroku może znacząco wpłynąć na Twoje wrażenia z podróży. Oto nasz kompletny przewodnik..."
    },
    post3: {
      title: "Kuchnia marokańska: kulinarna przygoda",
      author: "Layla Rahim",
      date: "5 marca 2024 r",
      category: "Jedzenie i kultura",
      excerpt: "Wyrusz w kulinarną podróż po Maroku. Odkryj bogate smaki, tradycyjne przepisy i doznania kulinarne, dzięki którym kuchnia marokańska jest znana na całym świecie.",
      content: "Kuchnia marokańska to mieszanka wpływów arabskich, berberyjskich, andaluzyjskich i afrykańskich. Każde danie opowiada historię różnorodnego dziedzictwa Maroka..."
    },
    post4: {
      title: "Jak targować się na rynkach marokańskich jak profesjonalista",
      author: "Youssefa Alaoui",
      date: "28 lutego 2024 r",
      category: "Wskazówki dotyczące podróży",
      excerpt: "Opanuj sztukę targowania się na marokańskich sukach i targowiskach. Poznaj etykietę kulturową, taktykę negocjacji i wskazówki, jak uzyskać najlepszą ofertę.",
      content: "Targowanie się to nie tylko transakcja na rynkach marokańskich; to wymiana kulturalna. Oto, jak to zrobić z szacunkiem i skutecznie..."
    },
    post5: {
      title: "Trekking w górach Atlas: co musisz wiedzieć",
      author: "Ahmeda Bennaniego",
      date: "20 lutego 2024 r",
      category: "Przygoda",
      excerpt: "Odkryj majestatyczne góry Atlas na piechotę. Uzyskaj porady ekspertów na temat tras trekkingowych, tego, co spakować, kwestii związanych z wysokością i najlepszego czasu na górską przygodę.",
      content: "Góry Atlas oferują jedne z najbardziej zapierających dech w piersiach krajobrazów w Afryce Północnej. Niezależnie od tego, czy jesteś doświadczonym turystą, czy początkującym..."
    },
    post6: {
      title: "Pustynne safari: niezapomniane przeżycie",
      author: "Fatima Hassan",
      date: "15 lutego 2024 r",
      category: "Przygoda",
      excerpt: "Poczuj magię Sahary w Maroku. Trekking na wielbłądach, gwiaździste noce pod płóciennymi namiotami i chwile o wschodzie słońca, których nigdy nie zapomnisz.",
      content: "Sahara reprezentuje duszę Maroka. Pustynne safari to coś więcej niż tylko przygoda; to duchowa podróż..."
    },
    post7: {
      title: "Etykieta kulturowa: poszanowanie tradycji marokańskich",
      author: "Layla Rahim",
      date: "10 lutego 2024 r",
      category: "Kultura",
      excerpt: "Poznaj podstawowe normy kulturowe, zwyczaje i etykietę, aby podczas wizyty szanować mieszkańców Maroka i tradycje.",
      content: "Zrozumienie i przestrzeganie lokalnych zwyczajów ma kluczowe znaczenie podczas podróży do Maroka. W tym przewodniku omówiono podstawowe praktyki kulturowe..."
    },
    post8: {
      title: "Fotografia w Maroku: uchwycenie magii",
      author: "Youssefa Alaoui",
      date: "5 lutego 2024 r",
      category: "Fotografia",
      excerpt: "Odkryj najbardziej fotogeniczne lokalizacje w Maroku i profesjonalne wskazówki, jak robić wspaniałe zdjęcia krajobrazów, ludzi i kultury.",
      content: "Maroko to raj dla fotografów. Od błękitnych medyn po złote pustynie, każdy zakątek oferuje niesamowite możliwości robienia zdjęć..."
    }
  },
  jobs: {
    title: "Kariera i możliwości",
    intro: "Dołącz do zespołu MarokoLovesYou i zbuduj swoją przyszłość w luksusowych podróżach",
    workWith: "Pracuj z miłością, troską i doskonałością",
    introText: "Poszukujemy pełnych pasji i oddanych osób, które podzielają naszą wizję dostarczania światowej klasy wrażeń z podróży. Dołącz do naszego rosnącego zespołu i bądź częścią czegoś wyjątkowego.",
    openPositions: "Otwarte pozycje",
    requirements: "Wymagania:",
    readyJoin: "Chcesz do nas dołączyć?",
    sendCV: "Wyślij swoje CV na adres care@moroccolovesyou.com",
    instructions: "Dołącz krótki list motywacyjny wyjaśniający, dlaczego chcesz dołączyć do zespołu Maroko Loves You.",
    emailCv: "Wyślij CV do dyrektora generalnego",
    chatCeo: "Porozmawiaj z dyrektorem generalnym na WhatsApp",
    job1: {
      title: "Wielojęzyczny profesjonalny przewodnik turystyczny",
      type: "Pełny etat/sezonowo",
      location: "Marrakesz / Fez / całe Maroko",
      description: "Poszukujemy przewodników pełnych pasji, posiadających wiedzę i opowiadających historie, którzy mogą ożywić Maroko dla naszych gości VIP. Twoja rola polega na prowadzeniu wycieczek premium, dzieleniu się spostrzeżeniami kulturowymi i zapewnianiu satysfakcji gości.",
      req1: "Biegła znajomość co najmniej 2 języków (preferowany francuski, hiszpański, angielski, hebrajski, niemiecki, rosyjski lub włoski)",
      req2: "Głęboka znajomość historii, kultury i geografii Maroka",
      req3: "Profesjonalizm, życzliwość i doskonałe podejście do klienta",
      req4: "Sprawność fizyczna do trekkingu po pustyni i zajęć na świeżym powietrzu"
    },
    job2: {
      title: "Kierowca VIP",
      type: "Pełny etat",
      location: "Całe Maroko",
      description: "Dołącz do naszego luksusowego zespołu transportowego, prowadzącego nowoczesne, wysokiej klasy pojazdy Mercedes. Zapewnisz transfery VIP, zapewnisz gościom komfort i bezpieczeństwo oraz będziesz reprezentować naszą markę profesjonalizmem i gościnnością.",
      req1: "Ważne prawo jazdy z doskonałym doświadczeniem (preferowane ponad 10 lat doświadczenia)",
      req2: "Biegła znajomość języka angielskiego (dodatkowe języki będą plusem)",
      req3: "Profesjonalny wygląd i uprzejme zachowanie",
      req4: "Znajomość dróg i szlaków Maroka; Doświadczenie z GPS/nawigacją"
    },
    job3: {
      title: "Koordynator ds. doświadczeń klientów",
      type: "Pełny etat",
      location: "Zdalny/hybrydowy (biuro w Fezie)",
      description: "Wesprzyj nasze biuro dyrektora generalnego w organizowaniu luksusowych niestandardowych tras, zarządzaniu komunikacją z gośćmi i zapewnianiu bezproblemowej koordynacji podróży. Ta rola jest idealna dla zorganizowanych i zorientowanych na szczegóły profesjonalistów.",
      req1: "Doskonałe umiejętności organizacyjne i komunikacyjne",
      req2: "Doświadczenie w branży turystycznej, hotelarsko-gastronomicznej lub obsłudze klienta",
      req3: "Biegle włada językiem angielskim; dodatkowe języki jako bonus",
      req4: "Znajomość systemów rezerwacyjnych i pakietu Microsoft Office"
    }
  },
  gallery_categories: {
    food: "Doświadczenie kulinarne",
    destinations: "Miejsca docelowe",
    kosher: "Koszerne",
    transport: "Transport VIP"
  }
};

export default pl;
